import GenerateEnum from '../generateEnum'
import {getLabelText} from '../utils.js'
// typeId: 和业务类型：VAT，EPR关联，    type:false 默认不选中    show: 目前国家是否上架     plantType:  归属哪个平台
// typeId： -1全部类型，VAT: 0, EPR: 1, 产品合规：3，  套餐：2， 商标专利：99， 跨境工商：999
// miniLabel: 小程序国家文案缩写展示，如果没有特殊要求不用新加此字段
// europeanUnion: 欧盟成员国
const COMMON_COUNTRY = new GenerateEnum({
    GB: {
        value: '0',
        label: getLabelText({key: 'remote.common.theUk', text: '英国'}),
        enLabel: 'The UK',
        typeId: '-1,0,1,3,99,999,20001,20002,20003,20004,20006,20007',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '2',
        complianceAssetCountryShow: true,
        nationality: 'British'
    },
    DE: {
        value: '2',
        label: getLabelText({key: 'remote.common.germany', text: '德国'}),
        enLabel: 'Germany',
        typeId: '-1,0,1,99,999,20001,20003',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '9',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'German'
    },
    FR: {
        value: '1',
        label: getLabelText({key: 'remote.common.france', text: '法国'}),
        enLabel: 'France',
        typeId: '-1,0,1,4,999,20001,20002,20003,20004,20006,20007',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '26',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'French'
    },
    IT: {
        value: '3',
        label: getLabelText({key: 'remote.common.italy', text: '意大利'}),
        enLabel: 'Italy',
        typeId: '-1,0,1,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '37',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Italian'
    },
    ES: {
        value: '4',
        label: getLabelText({key: 'remote.common.spain', text: '西班牙'}),
        enLabel: 'Spain',
        typeId: '-1,0,1,4,999,20003',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '35',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Spanish'
    },
    ES_CANARY: {
        value: '458',
        label: getLabelText({key: 'remote.common.canaryIslandsSpain', text: '加那利群岛（西班牙）'}),
        enLabel: 'Canary Islands (Spain)',
        typeId: '-1,0,1,4,999,20003',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '35',
        complianceAssetCountryShow: true,
        nationality: 'Spanish'
    },
    PL: {
        value: '5',
        label: getLabelText({key: 'remote.common.poland', text: '波兰'}),
        enLabel: 'Poland',
        typeId: '-1,0,1,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '29',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Polish'
    },
    CZ: {
        value: '6',
        label: getLabelText({key: 'remote.common.czechRepublic', text: '捷克'}),
        enLabel: 'Czech Republic',
        typeId: '-1,0,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '105',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Czech'
    },
    NL: {
        value: '7',
        label: getLabelText({key: 'remote.common.netherlands', text: '荷兰'}),
        enLabel: 'Netherlands',
        typeId: '-1,0,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '95',
        europeanUnion: true,
        nationality: 'Dutch'
    },
    SA: {
        value: '11',
        label: getLabelText({key: 'remote.common.saudiArabia', text: '沙特'}),
        enLabel: 'Saudi Arabia',
        typeId: '-1,0,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '16',
        complianceAssetCountryShow: true,
        nationality: 'Saudi'
    },
    UAE: {
        value: '12',
        label: getLabelText({key: 'remote.common.unitedArabEmirates', text: '阿联酋'}),
        enLabel: 'United Arab Emirates',
        typeId: '-1,0,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '15',
        complianceAssetCountryShow: true,
        nationality: 'Emirati'
    },
    AT: {
        value: '8',
        label: getLabelText({key: 'remote.common.austria', text: '奥地利'}),
        enLabel: 'Austria',
        typeId: '-1,0,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '50',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Austrian'
    },
    JP: {
        value: '100',
        label: getLabelText({key: 'remote.common.japan.text', text: '日本'}),
        enLabel: 'Japan',
        typeId: '-1,0,3,99,999,20001,20003',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '5',
        complianceAssetCountryShow: true,
        nationality: 'Japanese'
    },
    MX: {
        value: '34',
        label: getLabelText({key: 'remote.common.mexico', text: '墨西哥'}),
        enLabel: 'Mexico',
        typeId: '-1,0,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '13',
        complianceAssetCountryShow: true,
        nationality: 'Mexican'
    },
    EU: {
        value: '99',
        label: getLabelText({key: 'remote.common.europeanUnion', text: '欧盟'}),
        enLabel: 'European Union',
        typeId: '-1,0,3,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '2',
        complianceAssetCountryShow: true,
        nationality: ''
    },
    SE: {
        value: '10',
        label: getLabelText({key: 'remote.common.sweden', text: '瑞典'}),
        enLabel: 'Sweden',
        typeId: '-1,0,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '148',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Swedish'
    },
    BE: {
        value: '9',
        label: getLabelText({key: 'remote.common.belgium', text: '比利时'}),
        enLabel: 'Belgium',
        typeId: '-1,0',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '62',
        europeanUnion: true,
        nationality: 'Belgian'
    },
    IE: {
        value: '17',
        label: getLabelText({key: 'remote.common.ireland', text: '爱尔兰'}),
        enLabel: 'Ireland',
        typeId: '-1,0,1,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '45',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Irish'
    },
    EG: {
        value: '31',
        label: getLabelText({key: 'remote.common.egypt', text: '埃及'}),
        enLabel: 'Egypt',
        typeId: '-1,0',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '33',
        complianceAssetCountryShow: true,
        nationality: 'Egyptian'
    },
    CH: {
        value: '32',
        label: getLabelText({key: 'remote.common.switzerland', text: '瑞士'}),
        enLabel: 'Switzerland',
        typeId: '-1,0',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '31',
        complianceAssetCountryShow: true,
        nationality: 'Swiss'
    },
    US: {
        value: '101',
        label: getLabelText({key: 'remote.common.america', text: '美国'}),
        enLabel: 'America',
        typeId: '-1,3,99,999,20001,20002,20003,20004,20006,20007',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '1',
        complianceAssetCountryShow: true,
        nationality: 'American'
    },
    US_CA: {
        value: '902',
        label: getLabelText({key: 'remote.common.americaCalifornia', text: '美国加州'}),
        enLabel: 'America California',
        plantType: ['OST', 'LIUDU'],
        nationality: ''
    },
    TUR: {
        value: '33',
        label: getLabelText({key: 'remote.common.turkey', text: '土耳其'}),
        enLabel: 'Turkey',
        typeId: '-1,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '22',
        complianceAssetCountryShow: true,
        nationality: 'Turkish'
    },
    LT: {
        value: '21',
        label: getLabelText({key: 'remote.common.lithuania', text: '立陶宛'}),
        enLabel: 'Lithuania',
        typeId: '-1,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '117',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Lithuanian'
    },
    CY: {
        value: '26',
        label: getLabelText({key: 'remote.common.cyprus', text: '塞浦路斯'}),
        enLabel: 'Cyprus',
        typeId: '-1,0,4',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '154',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Cypriot'
    },
    AU: {
        value: '105',
        label: getLabelText({key: 'remote.common.australia', text: '澳大利亚'}),
        enLabel: 'Australia',
        typeId: '-1,0,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '10',
        complianceAssetCountryShow: true,
        nationality: 'Australian'
    },
    CA: {
        value: '106',
        label: getLabelText({key: 'remote.common.canada', text: '加拿大'}),
        enLabel: 'Canada',
        typeId: '-1,0,99',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '11',
        complianceAssetCountryShow: true,
        nationality: 'Canadian'
    },
    FI: {
        value: '13',
        label: getLabelText({key: 'remote.common.finland', text: '芬兰'}),
        enLabel: 'Finland',
        ippSort: '82',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Finnish'
    },
    DK: {
        value: '14',
        label: getLabelText({key: 'remote.common.denmark', text: '丹麦'}),
        enLabel: 'Denmark',
        typeId: '-1,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '73',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Danish'
    },
    GR: {
        value: '15',
        label: getLabelText({key: 'remote.common.greece', text: '希腊'}),
        enLabel: 'Greece',
        ippSort: '185',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Greek'
    },
    HU: {
        value: '16',
        label: getLabelText({key: 'remote.common.hungary', text: '匈牙利'}),
        enLabel: 'Hungary',
        ippSort: '186',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Hungarian'
    },
    LU: {
        value: '18',
        label: getLabelText({key: 'remote.common.luxembourg', text: '卢森堡'}),
        enLabel: 'Luxembourg',
        ippSort: '121',
        europeanUnion: true,
        nationality: 'Luxembourger'
    },
    MT: {
        value: '19',
        label: getLabelText({key: 'remote.common.malta', text: '马耳他'}),
        enLabel: 'Malta',
        ippSort: '127',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Maltese'
    },
    PT: {
        value: '20',
        label: getLabelText({key: 'remote.common.portugal', text: '葡萄牙'}),
        enLabel: 'Portugal',
        typeId: '-1,1',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '147',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Portuguese'
    },
    RO: {
        value: '22',
        label: getLabelText({key: 'remote.common.romania', text: '罗马尼亚'}),
        enLabel: 'Romania',
        ippSort: '124',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Romanian'
    },
    SK: {
        value: '23',
        label: getLabelText({key: 'remote.common.slovakia', text: '斯洛伐克'}),
        enLabel: 'Slovakia',
        typeId: '-1,0',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '162',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Slovak'
    },
    SI: {
        value: '24',
        label: getLabelText({key: 'remote.common.slovenia', text: '斯洛文尼亚'}),
        enLabel: 'Slovenia',
        ippSort: '163',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Slovenian'
    },
    BG: {
        value: '25',
        label: getLabelText({key: 'remote.common.bulgaria', text: '保加利亚'}),
        enLabel: 'Bulgaria',
        ippSort: '59',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Bulgarian'
    },
    HR: {
        value: '27',
        label: getLabelText({key: 'remote.common.croatia', text: '克罗地亚'}),
        enLabel: 'Croatia',
        ippSort: '110',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Croatian'
    },
    EE: {
        value: '28',
        label: getLabelText({key: 'remote.common.estonia', text: '爱沙尼亚'}),
        enLabel: 'Estonia',
        ippSort: '46',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Estonian'
    },
    LV: {
        value: '29',
        label: getLabelText({key: 'remote.common.latvia', text: '拉脱维亚'}),
        enLabel: 'Latvia',
        ippSort: '113',
        europeanUnion: true,
        complianceAssetCountryShow: true,
        nationality: 'Latvian'
    },
    XI: {
        value: '30',
        label: getLabelText({key: 'remote.common.northernIreland', text: '北爱尔兰'}),
        enLabel: 'Northern Ireland',
        typeId: '-1,999,20001,20003',
        type: false,
        show: true,
        plantType: ['XIAOMAO', 'LIUDU', 'TH'],
        complianceAssetCountryShow: true,
        nationality: ''
    },
    KR: {
        value: '102',
        label: getLabelText({key: 'remote.common.korea', text: '韩国'}),
        enLabel: 'Korea',
        typeId: '-1,99,999,20001,20003',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '6',
        complianceAssetCountryShow: true,
        nationality: 'South Korean'
    },
    PH: {
        value: '103',
        label: getLabelText({key: 'remote.common.philippines', text: '菲律宾'}),
        enLabel: 'Philippines',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '7',
        complianceAssetCountryShow: true,
        nationality: 'Filipino'
    },
    IN: {
        value: '104',
        label: getLabelText({key: 'remote.common.india', text: '印度'}),
        enLabel: 'India',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '8',
        complianceAssetCountryShow: true,
        nationality: 'Indian'
    },
    BR: {
        value: '107',
        label: getLabelText({key: 'remote.common.brazil', text: '巴西'}),
        enLabel: 'Brazil',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '12',
        complianceAssetCountryShow: true,
        nationality: 'Brazilian'
    },
    MY: {
        value: '113',
        label: getLabelText({key: 'remote.common.malaysia', text: '马来西亚'}),
        enLabel: 'Malaysia',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '14',
        complianceAssetCountryShow: true,
        nationality: 'Malaysian'
    },
    TH: {
        value: '116',
        label: getLabelText({key: 'remote.common.thailand', text: '泰国'}),
        enLabel: 'Thailand',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '17',
        complianceAssetCountryShow: true,
        nationality: 'Thai'
    },
    VN: {
        value: '117',
        label: getLabelText({key: 'remote.common.vietnam', text: '越南'}),
        enLabel: 'Vietnam',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '18',
        complianceAssetCountryShow: true,
        nationality: 'Vietnamese'
    },
    ID: {
        value: '119',
        label: getLabelText({key: 'remote.common.indonesia', text: '印度尼西亚'}),
        enLabel: 'Indonesia',
        miniLabel: '印尼',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '20',
        complianceAssetCountryShow: true,
        nationality: 'Indonesian'
    },
    SG: {
        value: '120',
        label: getLabelText({key: 'remote.common.singapore', text: '新加坡'}),
        enLabel: 'Singapore',
        typeId: '-1,99,999,20001,20002,20003,20004,20006,20007',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '21',
        complianceAssetCountryShow: true,
        nationality: 'Singaporean'
    },
    KH: {
        value: '118',
        label: getLabelText({key: 'remote.common.cambodia', text: '柬埔寨'}),
        enLabel: 'Cambodia',
        ippSort: '19',
        complianceAssetCountryShow: true,
        nationality: 'Cambodian'
    },
    MO: {
        value: '122',
        label: getLabelText({key: 'remote.common.macaoChina', text: '中国澳门'}),
        enLabel: 'Macao, China',
        typeId: '-1,999,20001,20003',
        type: false,
        show: true,
        plantType: ['XIAOMAO', 'LIUDU', 'TH'],
        ippSort: '23',
        complianceAssetCountryShow: true,
        nationality: 'Chinese'
    },
    TW: {
        value: '123',
        label: getLabelText({key: 'remote.common.taiwanChina', text: '中国台湾'}),
        enLabel: 'Taiwan, China',
        ippSort: '24',
        complianceAssetCountryShow: true,
        nationality: 'Chinese'
    },
    NZ: {
        value: '124',
        label: getLabelText({key: 'remote.common.newZealand', text: '新西兰'}),
        enLabel: 'New Zealand',
        ippSort: '25',
        complianceAssetCountryShow: true,
        nationality: 'New Zealander'
    },
    QA: {
        value: '126',
        label: getLabelText({key: 'remote.common.qatar', text: '卡塔尔'}),
        enLabel: 'Qatar',
        ippSort: '27',
        complianceAssetCountryShow: true,
        nationality: 'Qatari'
    },
    KW: {
        value: '127',
        label: getLabelText({key: 'remote.common.kuwait', text: '科威特'}),
        enLabel: 'Kuwait',
        ippSort: '28',
        complianceAssetCountryShow: true,
        nationality: 'Kuwaiti'
    },
    RU: {
        value: '129',
        label: getLabelText({key: 'remote.common.russia', text: '俄罗斯'}),
        enLabel: 'Russia',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        ippSort: '30',
        complianceAssetCountryShow: true,
        nationality: 'Russian'
    },
    CN: {
        value: '298',
        label: getLabelText({key: 'remote.common.china.text', text: '中国'}),
        enLabel: 'China',
        typeId: '-1,99,999,20011',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '4',
        complianceAssetCountryShow: true,
        nationality: 'Chinese'
    },
    HK: {
        value: '131',
        label: getLabelText({key: 'remote.common.hongKongChina', text: '中国香港'}),
        enLabel: 'Hong Kong, China',
        typeId: '-1,0,99,999,20001,20002,20003,20004,20006,20007',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH', 'XIAOMAO'],
        ippSort: '32',
        complianceAssetCountryShow: true,
        nationality: 'Chinese'
    },
    NG: {
        value: '133',
        label: getLabelText({key: 'remote.common.nigeria', text: '尼日利亚'}),
        enLabel: 'Nigeria',
        ippSort: '34',
        complianceAssetCountryShow: true,
        nationality: 'Nigerian'
    },
    ZA: {
        value: '135',
        label: getLabelText({key: 'remote.common.southAfrica', text: '南非'}),
        enLabel: 'South Africa',
        ippSort: '36',
        complianceAssetCountryShow: true,
        nationality: 'South African'
    },
    AL: {
        value: '137',
        label: getLabelText({key: 'remote.common.albania', text: '阿尔巴尼亚'}),
        enLabel: 'Albania',
        ippSort: '38',
        complianceAssetCountryShow: true,
        nationality: 'Albanian'
    },
    DZ: {
        value: '138',
        label: getLabelText({key: 'remote.common.algeria', text: '阿尔及利亚'}),
        enLabel: 'Algeria',
        ippSort: '39',
        complianceAssetCountryShow: true,
        nationality: 'Algerian'
    },
    AF: {
        value: '139',
        label: getLabelText({key: 'remote.common.afghanistan', text: '阿富汗'}),
        enLabel: 'Afghanistan',
        ippSort: '40',
        complianceAssetCountryShow: true,
        nationality: 'Afghan'
    },
    AR: {
        value: '140',
        label: getLabelText({key: 'remote.common.argentina', text: '阿根廷'}),
        enLabel: 'Argentina',
        ippSort: '41',
        complianceAssetCountryShow: true,
        nationality: 'Argentine'
    },
    OM: {
        value: '141',
        label: getLabelText({key: 'remote.common.oman', text: '阿曼'}),
        enLabel: 'Oman',
        ippSort: '42',
        complianceAssetCountryShow: true,
        nationality: 'Omani'
    },
    AZ: {
        value: '142',
        label: getLabelText({key: 'remote.common.azerbaijan', text: '阿塞拜疆'}),
        enLabel: 'Azerbaijan',
        ippSort: '43',
        complianceAssetCountryShow: true,
        nationality: 'Azerbaijani'
    },
    ET: {
        value: '143',
        label: getLabelText({key: 'remote.common.ethiopia', text: '埃塞俄比亚'}),
        enLabel: 'Ethiopia',
        ippSort: '44',
        complianceAssetCountryShow: true,
        nationality: 'Ethiopian'
    },
    AD: {
        value: '146',
        label: getLabelText({key: 'remote.common.andorra', text: '安道尔'}),
        enLabel: 'Andorra',
        ippSort: '47',
        nationality: 'Andorran'
    },
    AO: {
        value: '147',
        label: getLabelText({key: 'remote.common.angola', text: '安哥拉'}),
        enLabel: 'Angola',
        ippSort: '48',
        complianceAssetCountryShow: true,
        nationality: 'Angolan'
    },
    AG: {
        value: '148',
        label: getLabelText({key: 'remote.common.antiguaAndBarbuda', text: '安提瓜和巴布达'}),
        enLabel: 'Antigua and Barbuda',
        ippSort: '49',
        nationality: 'Antiguan, Barbudan'
    },
    BB: {
        value: '150',
        label: getLabelText({key: 'remote.common.barbados', text: '巴巴多斯'}),
        enLabel: 'remote.common.barbados',
        ippSort: '51',
        nationality: 'Barbadian'
    },
    PG: {
        value: '151',
        label: getLabelText({key: 'remote.common.papuaNewGuinea', text: '巴布亚新几内亚'}),
        enLabel: 'Papua New Guinea',
        ippSort: '52',
        nationality: 'Papua New Guinean'
    },
    BS: {
        value: '152',
        label: getLabelText({key: 'remote.common.theBahamas', text: '巴哈马'}),
        enLabel: 'The Bahamas',
        ippSort: '53',
        complianceAssetCountryShow: true,
        nationality: 'Bahamian'
    },
    PK: {
        value: '153',
        label: getLabelText({key: 'remote.common.pakistan', text: '巴基斯坦'}),
        enLabel: 'Pakistan',
        ippSort: '54',
        complianceAssetCountryShow: true,
        nationality: 'Pakistani'
    },
    PY: {
        value: '154',
        label: getLabelText({key: 'remote.common.paraguay', text: '巴拉圭'}),
        enLabel: 'Paraguay',
        ippSort: '55',
        complianceAssetCountryShow: true,
        nationality: 'Paraguayan'
    },
    BH: {
        value: '155',
        label: getLabelText({key: 'remote.common.bahrain', text: '巴林'}),
        enLabel: 'Bahrain',
        ippSort: '56',
        complianceAssetCountryShow: true,
        nationality: 'Bahraini'
    },
    PA: {
        value: '156',
        label: getLabelText({key: 'remote.common.panama', text: '巴拿马'}),
        enLabel: 'Panama',
        ippSort: '57',
        complianceAssetCountryShow: true,
        nationality: 'Panamanian'
    },
    BY: {
        value: '157',
        label: getLabelText({key: 'remote.common.belarus', text: '白俄罗斯'}),
        enLabel: 'Belarus',
        ippSort: '58',
        complianceAssetCountryShow: true,
        nationality: 'Belarusian'
    },
    MK: {
        value: '159',
        label: getLabelText({key: 'remote.common.northMacedonia', text: '北马其顿'}),
        enLabel: 'North Macedonia',
        ippSort: '60',
        nationality: 'Macedonian'
    },
    BJ: {
        value: '160',
        label: getLabelText({key: 'remote.common.benin', text: '贝宁'}),
        enLabel: 'Benin',
        ippSort: '61',
        nationality: 'Beninese'
    },
    PE: {
        value: '162',
        label: getLabelText({key: 'remote.common.peru', text: '秘鲁'}),
        enLabel: 'Peru',
        ippSort: '63',
        complianceAssetCountryShow: true,
        nationality: 'Peruvian'
    },
    IS: {
        value: '163',
        label: getLabelText({key: 'remote.common.iceland', text: '冰岛'}),
        enLabel: 'Iceland',
        ippSort: '64',
        nationality: 'Icelander'
    },
    BA: {
        value: '164',
        label: getLabelText({key: 'remote.common.bosniaAndHerzegovina', text: '波黑'}),
        enLabel: 'Bosnia and Herzegovina',
        ippSort: '65',
        nationality: 'Bosnian, Herzegovinian'
    },
    BZ: {
        value: '165',
        label: getLabelText({key: 'remote.common.belize', text: '伯利兹'}),
        enLabel: 'Belize',
        ippSort: '66',
        nationality: 'Belizean'
    },
    BW: {
        value: '166',
        label: getLabelText({key: 'remote.common.botswana', text: '博茨瓦纳'}),
        enLabel: 'Botswana',
        ippSort: '67',
        nationality: 'Motswana (单), Batswana (复)'
    },
    BT: {
        value: '167',
        label: getLabelText({key: 'remote.common.bhutan', text: '不丹'}),
        enLabel: 'Bhutan',
        ippSort: '68',
        nationality: 'Bhutanese'
    },
    BF: {
        value: '168',
        label: getLabelText({key: 'remote.common.burkinaFaso', text: '布基纳法索'}),
        enLabel: 'Burkina Faso',
        ippSort: '69',
        nationality: 'Burkinabe'
    },
    BI: {
        value: '169',
        label: getLabelText({key: 'remote.common.burundi', text: '布隆迪'}),
        enLabel: 'Burundi',
        ippSort: '70',
        nationality: 'Burundian'
    },
    KP: {
        value: '170',
        label: getLabelText({key: 'remote.common.northKorea', text: '朝鲜'}),
        enLabel: 'North Korea',
        ippSort: '71',
        complianceAssetCountryShow: true,
        nationality: 'North Korean'
    },
    CQ: {
        value: '171',
        label: getLabelText({key: 'remote.common.equatorialGuinea', text: '赤道几内亚'}),
        enLabel: 'Equatorial Guinea',
        ippSort: '72',
        nationality: 'Equatorial Guinean'
    },
    TP: {
        value: '173',
        label: getLabelText({key: 'remote.common.eastTimor', text: '东帝汶'}),
        enLabel: 'East Timor',
        ippSort: '74',
        complianceAssetCountryShow: true,
        nationality: 'Timorese'
    },
    TG: {
        value: '174',
        label: getLabelText({key: 'remote.common.togo', text: '多哥'}),
        enLabel: 'Togo',
        ippSort: '75',
        nationality: 'Togolese'
    },
    DO: {
        value: '175',
        label: getLabelText({key: 'remote.common.dominica', text: '多米尼加'}),
        enLabel: 'Dominica',
        ippSort: '76',
        complianceAssetCountryShow: true,
        nationality: 'Dominican'
    },
    PS: {
        value: '176',
        label: getLabelText({key: 'remote.common.palestine', text: '巴勒斯坦'}),
        enLabel: 'State of Palestine',
        ippSort: '77',
        complianceAssetCountryShow: true,
        nationality: 'Palestinian'
    },
    BO: {
        value: '177',
        label: getLabelText({key: 'remote.common.bolivia', text: '玻利维亚'}),
        enLabel: 'Bolivia',
        ippSort: '78',
        nationality: 'Bolivian'
    },
    EC: {
        value: '178',
        label: getLabelText({key: 'remote.common.ecuador', text: '厄瓜多尔'}),
        enLabel: 'Ecuador',
        ippSort: '79',
        complianceAssetCountryShow: true,
        nationality: 'Ecuadorian'
    },
    ER: {
        value: '179',
        label: getLabelText({key: 'remote.common.eritrea', text: '厄立特里亚'}),
        enLabel: '',
        ippSort: '80',
        nationality: 'Eritrean'
    },
    FJ: {
        value: '180',
        label: getLabelText({key: 'remote.common.fiji', text: '斐济'}),
        enLabel: 'Eritrea',
        ippSort: '81',
        nationality: 'Fijian'
    },
    CV: {
        value: '182',
        label: getLabelText({key: 'remote.common.capeVerde', text: '佛得角'}),
        enLabel: 'Cape Verde',
        ippSort: '83',
        nationality: 'Cabo Verdean'
    },
    GM: {
        value: '183',
        label: getLabelText({key: 'remote.common.theGambia', text: '冈比亚'}),
        enLabel: 'The Gambia',
        ippSort: '84',
        nationality: 'Gambian'
    },
    CG: {
        value: '184',
        label: getLabelText({key: 'remote.common.congo', text: '刚果'}),
        enLabel: 'Congo',
        ippSort: '85',
        nationality: 'Congolese'
    },
    CD: {
        value: '185',
        label: getLabelText({key: 'remote.common.congoKinshasa', text: '刚果(金)'}),
        enLabel: 'Congo (Kinshasa)',
        ippSort: '86',
        nationality: 'Congolese'
    },
    CO: {
        value: '186',
        label: getLabelText({key: 'remote.common.colombia', text: '哥伦比亚'}),
        enLabel: 'Colombia',
        ippSort: '87',
        complianceAssetCountryShow: true,
        nationality: 'Colombian'
    },
    CR: {
        value: '187',
        label: getLabelText({key: 'remote.common.costaRica', text: '哥斯达黎加'}),
        enLabel: 'Costa Rica',
        ippSort: '88',
        complianceAssetCountryShow: true,
        nationality: 'Costa Rican'
    },
    GD: {
        value: '188',
        label: getLabelText({key: 'remote.common.grenada', text: '格林纳达'}),
        enLabel: 'Grenada',
        ippSort: '89',
        nationality: 'Grenadian'
    },
    GE: {
        value: '189',
        label: getLabelText({key: 'remote.common.georgia', text: '格鲁吉亚'}),
        enLabel: 'Georgia',
        ippSort: '90',
        complianceAssetCountryShow: true,
        nationality: 'Georgian'
    },
    CU: {
        value: '190',
        label: getLabelText({key: 'remote.common.cuba', text: '古巴'}),
        enLabel: 'Cuba',
        ippSort: '91',
        complianceAssetCountryShow: true,
        nationality: 'Cuban'
    },
    GY: {
        value: '191',
        label: getLabelText({key: 'remote.common.guyana', text: '圭亚那'}),
        enLabel: 'Guyana',
        ippSort: '92',
        complianceAssetCountryShow: true,
        nationality: 'Guyanese'
    },
    KZ: {
        value: '192',
        label: getLabelText({key: 'remote.common.kazakhstan', text: '哈萨克斯坦'}),
        enLabel: 'Kazakhstan',
        ippSort: '93',
        complianceAssetCountryShow: true,
        nationality: 'Kazakhstani'
    },
    HT: {
        value: '193',
        label: getLabelText({key: 'remote.common.haiti', text: '海地'}),
        enLabel: 'Haiti',
        ippSort: '94',
        nationality: 'Haitian'
    },
    ME: {
        value: '195',
        label: getLabelText({key: 'remote.common.montenegro', text: '黑山'}),
        enLabel: 'Montenegro',
        ippSort: '96',
        nationality: 'Montenegrin'
    },
    HN: {
        value: '196',
        label: getLabelText({key: 'remote.common.honduras', text: '洪都拉斯'}),
        enLabel: '',
        ippSort: '97',
        nationality: 'Honduran'
    },
    KI: {
        value: '197',
        label: getLabelText({key: 'remote.common.kiribati', text: '基里巴斯'}),
        enLabel: 'Honduras',
        ippSort: '98',
        nationality: 'I-Kiribati'
    },
    DJ: {
        value: '198',
        label: getLabelText({key: 'remote.common.djibouti', text: '吉布提'}),
        enLabel: 'Djibouti',
        ippSort: '99',
        nationality: 'Djibouti'
    },
    KG: {
        value: '199',
        label: getLabelText({key: 'remote.common.kyrgyzstan', text: '吉尔吉斯斯坦'}),
        enLabel: 'Kyrgyzstan',
        ippSort: '100',
        complianceAssetCountryShow: true,
        nationality: 'Kyrgyzstani'
    },
    GN: {
        value: '200',
        label: getLabelText({key: 'remote.common.guinea', text: '几内亚'}),
        enLabel: 'Guinea',
        ippSort: '101',
        nationality: 'Guinean'
    },
    GW: {
        value: '201',
        label: getLabelText({key: 'remote.common.guinea-bissau', text: '几内亚比绍'}),
        enLabel: 'Guinea-Bissau',
        ippSort: '102',
        nationality: 'Bissau-Guinean'
    },
    GH: {
        value: '202',
        label: getLabelText({key: 'remote.common.ghana', text: '加纳'}),
        enLabel: 'Ghana',
        ippSort: '103',
        complianceAssetCountryShow: true,
        nationality: 'Ghanaian'
    },
    GA: {
        value: '203',
        label: getLabelText({key: 'remote.common.gabon', text: '加蓬'}),
        enLabel: 'Gabon',
        ippSort: '104',
        nationality: 'Gabonese'
    },
    ZW: {
        value: '205',
        label: getLabelText({key: 'remote.common.zimbabwe', text: '津巴布韦'}),
        enLabel: 'Zimbabwe',
        ippSort: '106',
        complianceAssetCountryShow: true,
        nationality: 'Zimbabwean'
    },
    CM: {
        value: '206',
        label: getLabelText({key: 'remote.common.cameroon', text: '喀麦隆'}),
        enLabel: 'Cameroon',
        ippSort: '107',
        nationality: 'Cameroonian'
    },
    KM: {
        value: '207',
        label: getLabelText({key: 'remote.common.comoros', text: '科摩罗'}),
        enLabel: 'Comoros',
        ippSort: '108',
        nationality: 'Comoran'
    },
    CI: {
        value: '208',
        label: getLabelText({key: 'remote.common.coteDLvoire', text: '科特迪瓦'}),
        enLabel: 'Ivory Coast',
        ippSort: '109',
        nationality: 'Ivorian'
    },
    KE: {
        value: '210',
        label: getLabelText({key: 'remote.common.kenya', text: '肯尼亚'}),
        enLabel: 'Kenya',
        ippSort: '111',
        complianceAssetCountryShow: true,
        nationality: 'Kenyan'
    },
    CK: {
        value: '211',
        label: getLabelText({key: 'remote.common.cookIslands', text: '库克群岛'}),
        enLabel: 'Cook Islands',
        ippSort: '112',
        nationality: 'Cook Islander'
    },
    LS: {
        value: '213',
        label: getLabelText({key: 'remote.common.lesotho', text: '莱索托'}),
        enLabel: 'Lesotho',
        ippSort: '114',
        nationality: 'Mosotho (单), Basotho (复)'
    },
    LA: {
        value: '214',
        label: getLabelText({key: 'remote.common.laos', text: '老挝'}),
        enLabel: 'Laos',
        ippSort: '115',
        complianceAssetCountryShow: true,
        nationality: 'Lao'
    },
    LB: {
        value: '215',
        label: getLabelText({key: 'remote.common.lebanon', text: '黎巴嫩'}),
        enLabel: 'Lebanon',
        ippSort: '116',
        complianceAssetCountryShow: true,
        nationality: 'Lebanese'
    },
    LR: {
        value: '217',
        label: getLabelText({key: 'remote.common.liberia', text: '利比里亚'}),
        enLabel: 'Liberia',
        ippSort: '118',
        complianceAssetCountryShow: true,
        nationality: 'Liberian'
    },
    LY: {
        value: '218',
        label: getLabelText({key: 'remote.common.libya', text: '利比亚'}),
        enLabel: 'Libya',
        ippSort: '119',
        complianceAssetCountryShow: true,
        nationality: 'Libyan'
    },
    LI: {
        value: '219',
        label: getLabelText({key: 'remote.common.liechtenstein', text: '列支敦士登'}),
        enLabel: 'Liechtenstein',
        ippSort: '120',
        nationality: 'Liechtensteiner'
    },
    RW: {
        value: '221',
        label: getLabelText({key: 'remote.common.rwanda', text: '卢旺达'}),
        enLabel: 'Rwanda',
        ippSort: '122',
        nationality: 'Rwandan'
    },
    VA: {
        value: '222',
        label: getLabelText({key: 'remote.common.theVatican', text: '梵蒂冈'}),
        enLabel: 'The Vatican',
        ippSort: '123',
        nationality: 'Vatican'
    },
    MG: {
        value: '224',
        label: getLabelText({key: 'remote.common.madagascar', text: '马达加斯加'}),
        enLabel: 'Madagascar',
        ippSort: '125',
        nationality: 'Malagasy'
    },
    MV: {
        value: '225',
        label: getLabelText({key: 'remote.common.maldives', text: '马尔代夫'}),
        enLabel: 'Maldives',
        ippSort: '126',
        nationality: 'Maldivian'
    },
    MW: {
        value: '227',
        label: getLabelText({key: 'remote.common.malawi', text: '马拉维'}),
        enLabel: 'Malawi',
        ippSort: '128',
        nationality: 'Malawian'
    },
    ML: {
        value: '228',
        label: getLabelText({key: 'remote.common.mali', text: '马里'}),
        enLabel: 'Mali',
        ippSort: '129',
        nationality: 'Malian'
    },
    MH: {
        value: '229',
        label: getLabelText({key: 'remote.common.marshallIslands', text: '马绍尔群岛'}),
        enLabel: 'Marshall Islands',
        ippSort: '130',
        nationality: 'Marshallese'
    },
    MU: {
        value: '230',
        label: getLabelText({key: 'remote.common.mauritius', text: '毛里求斯'}),
        enLabel: 'Mauritius',
        ippSort: '131',
        complianceAssetCountryShow: true,
        nationality: 'Mauritian'
    },
    MR: {
        value: '231',
        label: getLabelText({key: 'remote.common.mauritania', text: '毛里塔尼亚'}),
        enLabel: 'Mauritania',
        ippSort: '132',
        nationality: 'Mauritanian'
    },
    EU_UK: {
        value: '901',
        label: getLabelText({key: 'remote.common.Europe', text: '欧洲（英+欧盟）'}),
        enLabel: 'Europe',
        plantType: ['OST', 'LIUDU'],
        nationality: ''
    },
    AMERICAS: {
        value: '900',
        label: getLabelText({key: 'remote.common.theAmericas', text: '北美'}),
        enLabel: 'the Americas',
        plantType: ['OST', 'LIUDU'],
        nationality: ''
    },
    MN: {
        value: '232',
        label: getLabelText({key: 'remote.common.mongolia', text: '蒙古'}),
        enLabel: 'Mongolia',
        ippSort: '133',
        complianceAssetCountryShow: true,
        nationality: 'Mongolian'
    },
    BD: {
        value: '233',
        label: getLabelText({key: 'remote.common.bangladesh', text: '孟加拉国'}),
        enLabel: 'Bangladesh',
        ippSort: '134',
        complianceAssetCountryShow: true,
        nationality: 'Bangladeshi'
    },
    MM: {
        value: '234',
        label: getLabelText({key: 'remote.common.burma', text: '缅甸'}),
        enLabel: 'Burma',
        ippSort: '135',
        complianceAssetCountryShow: true,
        nationality: 'Burmese'
    },
    MD: {
        value: '235',
        label: getLabelText({key: 'remote.common.moldova', text: '摩尔多瓦'}),
        enLabel: 'Moldova',
        ippSort: '136',
        complianceAssetCountryShow: true,
        nationality: 'Moldovan'
    },
    MA: {
        value: '236',
        label: getLabelText({key: 'remote.common.morocco', text: '摩洛哥'}),
        enLabel: 'Morocco',
        ippSort: '137',
        complianceAssetCountryShow: true,
        nationality: 'Moroccan'
    },
    MC: {
        value: '237',
        label: getLabelText({key: 'remote.common.monaco', text: '摩纳哥'}),
        enLabel: 'Monaco',
        ippSort: '138',
        complianceAssetCountryShow: true,
        nationality: 'Monegasque'
    },
    MZ: {
        value: '238',
        label: getLabelText({key: 'remote.common.mozambique', text: '莫桑比克'}),
        enLabel: 'Mozambique',
        ippSort: '139',
        complianceAssetCountryShow: true,
        nationality: 'Mozambican'
    },
    NA: {
        value: '239',
        label: getLabelText({key: 'remote.common.namibia', text: '纳米比亚'}),
        enLabel: 'Namibia',
        ippSort: '140',
        complianceAssetCountryShow: true,
        nationality: 'Namibian'
    },
    NR: {
        value: '240',
        label: getLabelText({key: 'remote.common.nauru', text: '瑙鲁'}),
        enLabel: 'Nauru',
        ippSort: '141',
        nationality: 'Nauruan'
    },
    NP: {
        value: '241',
        label: getLabelText({key: 'remote.common.nepal', text: '尼泊尔'}),
        enLabel: 'Nepal',
        ippSort: '142',
        complianceAssetCountryShow: true,
        nationality: 'Nepali'
    },
    NI: {
        value: '242',
        label: getLabelText({key: 'remote.common.nicaragua', text: '尼加拉瓜'}),
        enLabel: 'Nicaragua',
        ippSort: '143',
        nationality: 'Nicaraguan'
    },
    NE: {
        value: '243',
        label: getLabelText({key: 'remote.common.niger', text: '尼日尔'}),
        enLabel: 'Niger',
        ippSort: '144',
        nationality: 'Nigerien'
    },
    NU: {
        value: '244',
        label: getLabelText({key: 'remote.common.niue', text: '纽埃'}),
        enLabel: 'Niue',
        ippSort: '145',
        nationality: 'Niuean'
    },
    NO: {
        value: '245',
        label: getLabelText({key: 'remote.common.norway', text: '挪威'}),
        enLabel: 'Norway',
        typeId: '-1,0',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH'],
        ippSort: '146',
        complianceAssetCountryShow: true,
        nationality: 'Norwegian'
    },
    EV: {
        value: '248',
        label: getLabelText({key: 'remote.common.elSalvador', text: '萨尔瓦多'}),
        enLabel: 'El Salvador',
        ippSort: '149',
        complianceAssetCountryShow: true,
        nationality: 'Salvadoran'
    },
    WS: {
        value: '249',
        label: getLabelText({key: 'remote.common.samoa', text: '萨摩亚'}),
        enLabel: 'Samoa',
        ippSort: '150',
        nationality: 'Samoan'
    },
    RS: {
        value: '250',
        label: getLabelText({key: 'remote.common.serbia', text: '塞尔维亚'}),
        enLabel: 'Serbia',
        ippSort: '151',
        complianceAssetCountryShow: true,
        nationality: 'Serbian'
    },
    SL: {
        value: '251',
        label: getLabelText({key: 'remote.common.sierraLeone', text: '塞拉利昂'}),
        enLabel: 'Sierra Leone',
        ippSort: '152',
        nationality: 'Sierra Leonean'
    },
    SN: {
        value: '252',
        label: getLabelText({key: 'remote.common.senegal', text: '塞内加尔'}),
        enLabel: 'Senegal',
        ippSort: '153',
        nationality: 'Senegalese'
    },
    SC: {
        value: '254',
        label: getLabelText({key: 'remote.common.seychelles', text: '塞舌尔'}),
        enLabel: 'Seychelles',
        typeId: '-1,999,20001',
        type: false,
        show: true,
        plantType: ['XIAOMAO', 'LIUDU', 'TH'],
        ippSort: '155',
        nationality: 'Seychellois'
    },
    ST: {
        value: '255',
        label: getLabelText({key: 'remote.common.saoTomeAndPrincipe', text: '圣多美和普林西比'}),
        enLabel: 'Sao Tome and Principe',
        ippSort: '156',
        nationality: 'Sao Tomean'
    },
    KN: {
        value: '256',
        label: getLabelText({key: 'remote.common.saintKittsAndNevis', text: '圣基茨和尼维斯'}),
        enLabel: 'Saint Kitts and Nevis',
        ippSort: '157',
        nationality: 'Kittitian, Nevisian'
    },
    LC: {
        value: '257',
        label: getLabelText({key: 'remote.common.saintLucia', text: '圣卢西亚'}),
        enLabel: 'Saint Lucia',
        ippSort: '158',
        nationality: 'Saint Lucian'
    },
    SM: {
        value: '258',
        label: getLabelText({key: 'remote.common.sanMarino', text: '圣马力诺'}),
        enLabel: 'San Marino',
        ippSort: '159',
        nationality: 'Sammarinese'
    },
    VC: {
        value: '259',
        label: getLabelText({key: 'remote.common.saintVincentAndTheGrenadines', text: '圣文森特和格林纳丁斯'}),
        enLabel: 'Saint Vincent and the Grenadines',
        ippSort: '160',
        nationality: 'Vincentian'
    },
    LK: {
        value: '260',
        label: getLabelText({key: 'remote.common.sriLanka', text: '斯里兰卡'}),
        enLabel: 'Sri Lanka',
        ippSort: '161',
        complianceAssetCountryShow: true,
        nationality: 'Sri Lankan'
    },
    SZ: {
        value: '263',
        label: getLabelText({key: 'remote.common.swaziland', text: '斯威士兰'}),
        enLabel: 'Swaziland',
        ippSort: '164',
        nationality: 'Swazi'
    },
    SD: {
        value: '264',
        label: getLabelText({key: 'remote.common.sudan', text: '苏丹'}),
        enLabel: 'Sudan',
        ippSort: '165',
        nationality: 'Sudanese'
    },
    SS: {
        value: '265',
        label: getLabelText({key: 'remote.common.southSudan', text: '南苏丹'}),
        enLabel: 'South Sudan',
        ippSort: '166',
        nationality: 'South Sudanese'
    },
    SR: {
        value: '266',
        label: getLabelText({key: 'remote.common.suriname', text: '苏里南'}),
        enLabel: 'Suriname',
        ippSort: '167',
        nationality: 'Surinamese'
    },
    SB: {
        value: '267',
        label: getLabelText({key: 'remote.common.solomonIslands', text: '所罗门群岛'}),
        enLabel: 'Solomon Islands',
        ippSort: '168',
        nationality: 'Solomon Islander'
    },
    SO: {
        value: '268',
        label: getLabelText({key: 'remote.common.somalia', text: '索马里'}),
        enLabel: 'Somalia',
        ippSort: '169',
        complianceAssetCountryShow: true,
        nationality: 'Somali'
    },
    TJ: {
        value: '269',
        label: getLabelText({key: 'remote.common.tajikistan', text: '塔吉克斯坦'}),
        enLabel: 'Tajikistan',
        ippSort: '170',
        complianceAssetCountryShow: true,
        nationality: 'Tajik'
    },
    TZ: {
        value: '270',
        label: getLabelText({key: 'remote.common.tanzania', text: '坦桑尼亚'}),
        enLabel: 'Tanzania',
        ippSort: '171',
        complianceAssetCountryShow: true,
        nationality: 'Tanzanian'
    },
    TO: {
        value: '271',
        label: getLabelText({key: 'remote.common.tonga', text: '汤加'}),
        enLabel: 'Tonga',
        ippSort: '172',
        nationality: 'Tongan'
    },
    TT: {
        value: '272',
        label: getLabelText({key: 'remote.common.trinidadAndTobago', text: '特立尼达和多巴哥'}),
        enLabel: 'Trinidad and Tobago',
        ippSort: '173',
        nationality: 'Trinidadian, Tobagonian'
    },
    TN: {
        value: '273',
        label: getLabelText({key: 'remote.common.tunisia', text: '突尼斯'}),
        enLabel: 'Tunisia',
        ippSort: '174',
        nationality: 'Tunisian'
    },
    TV: {
        value: '274',
        label: getLabelText({key: 'remote.common.tuvalu', text: '图瓦卢'}),
        enLabel: 'Tuvalu',
        ippSort: '175',
        nationality: 'Tuvaluan'
    },
    TM: {
        value: '275',
        label: getLabelText({key: 'remote.common.turkmenistan', text: '土库曼斯坦'}),
        enLabel: 'Turkmenistan',
        ippSort: '176',
        nationality: 'Turkmen'
    },
    VU: {
        value: '276',
        label: getLabelText({key: 'remote.common.vanuatu', text: '瓦努阿图'}),
        enLabel: 'Vanuatu',
        ippSort: '177',
        nationality: 'Ni-Vanuatu'
    },
    GT: {
        value: '277',
        label: getLabelText({key: 'remote.common.guatemala', text: '危地马拉'}),
        enLabel: 'Guatemala',
        ippSort: '178',
        nationality: 'Guatemalan'
    },
    VE: {
        value: '278',
        label: getLabelText({key: 'remote.common.venezuela', text: '委内瑞拉'}),
        enLabel: 'Venezuela',
        ippSort: '179',
        complianceAssetCountryShow: true,
        nationality: 'Venezuelan'
    },
    BN: {
        value: '279',
        label: getLabelText({key: 'remote.common.brunei', text: '文莱'}),
        enLabel: 'Brunei',
        ippSort: '180',
        nationality: 'Bruneian'
    },
    UG: {
        value: '280',
        label: getLabelText({key: 'remote.common.uganda', text: '乌干达'}),
        enLabel: 'Uganda',
        ippSort: '181',
        complianceAssetCountryShow: true,
        nationality: 'Ugandan'
    },
    UA: {
        value: '281',
        label: getLabelText({key: 'remote.common.ukraine', text: '乌克兰'}),
        enLabel: 'Ukraine',
        ippSort: '182',
        complianceAssetCountryShow: true,
        nationality: 'Ukrainian'
    },
    UY: {
        value: '282',
        label: getLabelText({key: 'remote.common.uruguay', text: '乌拉圭'}),
        enLabel: 'Uruguay',
        ippSort: '183',
        complianceAssetCountryShow: true,
        nationality: 'Uruguayan'
    },
    UZ: {
        value: '283',
        label: getLabelText({key: 'remote.common.uzbekistan', text: '乌兹别克斯坦'}),
        enLabel: 'Uzbekistan',
        ippSort: '184',
        complianceAssetCountryShow: true,
        nationality: 'Uzbek'
    },
    SY: {
        value: '286',
        label: getLabelText({key: 'remote.common.syria', text: '叙利亚'}),
        enLabel: 'Syria',
        ippSort: '187',
        complianceAssetCountryShow: true,
        nationality: 'Syrian'
    },
    JM: {
        value: '287',
        label: getLabelText({key: 'remote.common.jamaica', text: '牙买加'}),
        enLabel: 'Jamaica',
        ippSort: '188',
        nationality: 'Jamaican'
    },
    AM: {
        value: '288',
        label: getLabelText({key: 'remote.common.armenia', text: '亚美尼亚'}),
        enLabel: 'Armenia',
        ippSort: '189',
        complianceAssetCountryShow: true,
        nationality: 'Armenian'
    },
    YE: {
        value: '289',
        label: getLabelText({key: 'remote.common.yemen', text: '也门'}),
        enLabel: 'Yemen',
        ippSort: '190',
        complianceAssetCountryShow: true,
        nationality: 'Yemeni'
    },
    IQ: {
        value: '290',
        label: getLabelText({key: 'remote.common.iraq', text: '伊拉克'}),
        enLabel: 'Iraq',
        ippSort: '191',
        complianceAssetCountryShow: true,
        nationality: 'Iraqi'
    },
    IR: {
        value: '291',
        label: getLabelText({key: 'remote.common.iran', text: '伊朗'}),
        enLabel: 'Iran',
        ippSort: '192',
        complianceAssetCountryShow: true,
        nationality: 'Iranian'
    },
    IL: {
        value: '292',
        label: getLabelText({key: 'remote.common.israel', text: '以色列'}),
        enLabel: 'Israel',
        ippSort: '193',
        complianceAssetCountryShow: true,
        nationality: 'Israeli'
    },
    JO: {
        value: '293',
        label: getLabelText({key: 'remote.common.jordan', text: '约旦'}),
        enLabel: 'Jordan',
        ippSort: '194',
        complianceAssetCountryShow: true,
        nationality: 'Jordanian'
    },
    ZM: {
        value: '294',
        label: getLabelText({key: 'remote.common.zambia', text: '赞比亚'}),
        enLabel: 'Zambia',
        ippSort: '195',
        complianceAssetCountryShow: true,
        nationality: 'Zambian'
    },
    TD: {
        value: '295',
        label: getLabelText({key: 'remote.common.chad', text: '乍得'}),
        enLabel: 'Chad',
        ippSort: '196',
        nationality: 'Chadian'
    },
    CL: {
        value: '296',
        label: getLabelText({key: 'remote.common.chile', text: '智利'}),
        enLabel: 'Chile',
        ippSort: '197',
        complianceAssetCountryShow: true,
        nationality: 'Chilean'
    },
    CF: {
        value: '297',
        label: getLabelText({key: 'remote.common.centralAfrica', text: '中非'}),
        enLabel: 'Central African Republic',
        ippSort: '198',
        nationality: 'Central African'
    },
    BVI: {
        value: '400',
        label: getLabelText({key: 'remote.common.BVI', text: 'BVI'}),
        enLabel: 'BVI',
        typeId: '-1,999,20001',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH', 'XIAOMAO'],
        nationality: ''
    },
    AI: {
        value: '401',
        label: getLabelText({key: 'remote.common.anguilla', text: '安圭拉'}),
        enLabel: 'Anguilla',
        complianceAssetCountryShow: true,
        nationality: 'Anguilla'
    },
    IO: {
        value: '407',
        label: getLabelText({key: 'remote.common.IO', text: '英属印度洋领地'}),
        enLabel: 'IO',
        nationality: ''
    },
    PR: {
        value: '438',
        label: getLabelText({key: 'remote.common.puertoRico', text: '波多黎各'}),
        enLabel: 'Puerto Rico',
        complianceAssetCountryShow: true,
        nationality: 'Puerto Rico'
    },
    WORLD: {
        value: '999',
        label: getLabelText({key: 'remote.common.global', text: '全球'}),
        enLabel: 'Global',
        typeId: '-1,0,1,3,999,20001,20002,20003,20004,20006,20007,20011',
        type: false,
        show: true,
        plantType: ['OST', 'LIUDU', 'TH', 'XIAOMAO'],
        nationality: ''
    },
    OAPI: {
        value: '299',
        label: getLabelText({key: 'remote.common.africanIntellectualPropertyOrganization', text: '非洲知识产权组织'}),
        enLabel: 'African Intellectual Property Organization',
        ippSort: '199',
        complianceAssetCountryShow: true,
        nationality: ''
    },
    BOIP: {
        value: '300',
        label: getLabelText({key: 'remote.common.beneluxIntellectualPropertyOrganization', text: '比荷卢知识产权组织'}),
        enLabel: 'Benelux Intellectual Property Organization',
        ippSort: '200',
        complianceAssetCountryShow: true,
        nationality: ''
    },
    ARIPO: {
        value: '301',
        label: getLabelText({
            key: 'remote.common.africanRegionalIndustrialPropertyOrganization',
            text: '非洲地区工业产权组织'
        }),
        enLabel: 'African Regional Industrial Property Organization',
        ippSort: '201',
        complianceAssetCountryShow: true,
        nationality: ''
    },
    MACIRM: {
        value: '302',
        label: getLabelText({key: 'remote.common.madridSystem', text: '马德里体系'}),
        enLabel: 'Madrid system',
        ippSort: '202',
        nationality: ''
    },
    HAGUE: {
        value: '303',
        label: getLabelText({key: 'remote.common.hagueSystem', text: '海牙体系'}),
        enLabel: 'Hague System ',
        ippSort: '203',
        nationality: ''
    },
    CUSTOM_UNIVERSAL: {
        value: '600',
        label: getLabelText({key: 'remote.common.moreCountry', text: '更多国家/地区'}),
        enLabel: 'More countries/regions',
        label2: getLabelText({key: 'remote.common.generalCountries', text: '通用国家'}),
        miniLabel: '更多',
        typeId: '-1,99',
        type: false,
        show: true,
        plantType: ['LIUDU', 'TH'],
        nationality: ''
    }
})


const europeanUnionCountryKeys = [
    'AT',   // 奥地利
    'BE',   // 比利时
    'BG',   // 保加利亚
    'CY',   // 塞浦路斯
    'HR',   // 克罗地亚
    'CZ',   // 捷克
    'DK',   // 丹麦
    'EE',   // 爱沙尼亚
    'FI',   // 芬兰
    'FR',   // 法国
    'DE',   // 德国
    'GR',   // 希腊
    'HU',   // 匈牙利
    'IE',   // 爱尔兰
    'IT',   // 意大利
    'LV',   // 拉脱维亚
    'LT',   // 立陶宛
    'LU',   // 卢森堡
    'MT',   // 马耳他
    'NL',   // 荷兰
    'PL',   // 波兰
    'PT',   // 葡萄牙
    'RO',   // 罗马尼亚
    'SK',   // 斯洛伐克
    'SI',   // 斯洛文尼亚
    'ES',   // 西班牙
    'SE'    // 瑞典
];
// 欧盟27国
const europeanUnionCountryEnum = COMMON_COUNTRY.generateEnumValue(europeanUnionCountryKeys)


export {COMMON_COUNTRY, europeanUnionCountryEnum}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/commonCountry.js